import {RouteDefinition} from "../../../routes"
import {ServiceAlarmLogsScreen} from "./ServiceAlarmLogs"
import {BootLogsScreen} from "./BootLogs"
import {CallLogsScreen} from "./CallListLogs"
import {ErrorLogsScreen} from "./ErrorLogs"
import {LogScreen} from "./LogScreen"
import {MappingLogsScreen} from "./MappingLogs"
import {RFTestLogsScreen} from "./RFTestLogs"
import {UserLogs} from "./UserLogs"
import {AlarmLogsScreen} from "./AlarmLogs"
import {NotificationLogs} from "./NotificationLogs"

export const LogsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/logs",
        component: LogScreen
    },
    {
        routerLink: "/settings/logs/user-logs",
        component: UserLogs
    },
    {
        routerLink: "/settings/logs/call-logs",
        component: CallLogsScreen
    },
    {
        routerLink: "/settings/logs/boot-logs",
        component: BootLogsScreen
    },
    {
        routerLink: "/settings/logs/error-logs",
        component: ErrorLogsScreen
    },
    {
        routerLink: "/settings/logs/service-alarm-logs",
        component: ServiceAlarmLogsScreen
    },
    {
        routerLink: "/settings/logs/alarm-logs",
        component: AlarmLogsScreen
    },
    {
        routerLink: "/settings/logs/mapping-logs",
        component: MappingLogsScreen
    },
    {
        routerLink: "/settings/logs/rftest-logs",
        component: RFTestLogsScreen
    },
    {
        routerLink: "/settings/logs/notification-logs",
        component: NotificationLogs
    }
]
